import {
  ADD_ADMIN_REQUEST,
  GET_ADMINS_REQUEST,
  GET_ADMINS_RESPONSE,
  EDIT_ADMIN_REQUEST,
  GET_ADMIN_DETAILS_REQUEST,
  GET_ADMIN_DETAILS_RESPONSE,
  DELETE_ADMIN_REQUEST,
} from "./types";

// list
export const getAdminsRequest = (payload) => ({
  type: GET_ADMINS_REQUEST,
  payload,
});

export const getAdminsResponse = (payload) => ({
  type: GET_ADMINS_RESPONSE,
  payload,
});

// add
export const addAdminRequest = (payload) => ({
  type: ADD_ADMIN_REQUEST,
  payload,
});

// edit
export const editAdminRequest = (payload) => ({
  type: EDIT_ADMIN_REQUEST,
  payload,
});

// get by id (view)
export const getAdminDetailsRequest = (payload) => ({
  type: GET_ADMIN_DETAILS_REQUEST,
  payload,
});

export const getAdminDetailsResponse = (payload) => ({
  type: GET_ADMIN_DETAILS_RESPONSE,
  payload,
});

export const deleteAdminRequest = (payload) => ({
  type: DELETE_ADMIN_REQUEST,
  payload,
});
